exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "md-tabs.direct-deposit md-tab-content {\n  padding-top:20px;\n}\n\ntable.payments {\n  font-size: 13px;\n}", ""]);

// exports
